import React from 'react'

interface AuthLayoutProps {
  children: React.ReactNode
}

// Stats de marca do hero (estaticas, conforme o handoff — nao sao metricas reais).
const HERO_STATS = [
  { big: 'IA', label: 'Narrador do livro' },
  { big: '∞', label: 'Sessões ao vivo' },
  { big: 'd20', label: 'Dados na mesa' },
]

function Wordmark({ small = false }: { small?: boolean }) {
  return (
    <div className={small ? 'flex items-baseline gap-1' : 'flex items-baseline gap-1.5'}>
      <span className={`font-black tracking-tight text-white ${small ? 'text-lg' : 'text-2xl'}`}>
        EDURPG<span className="text-hero-accent">.IA</span>
      </span>
    </div>
  )
}

// Shell das telas de auth (redesign 2026-07): split 50/50 no desktop —
// painel cinema-dark (--hero-bg, device de marca; muda com o tema da conta)
// + coluna clara com o form. No mobile vira faixa hero compacta com a folha
// do form sobreposta (cantos arredondados).
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-background">
      {/* ---- painel hero (desktop) ---- */}
      <div className="relative hidden lg:flex lg:w-1/2 flex-col justify-between overflow-hidden bg-hero p-12 text-white">
        <div className="hero-glow" aria-hidden="true" />

        <div className="relative">
          <Wordmark />
          <p className="mt-1 text-sm text-white/60">Plataforma de RPG educacional com IA</p>
        </div>

        <div className="relative max-w-md">
          <h1 className="font-black italic uppercase leading-[0.95] tracking-[-0.035em] text-6xl">
            A cada <span className="text-hero-accent">missão</span>
            <br />
            um novo <span className="text-hero-accent">aprendizado</span>.
          </h1>
        </div>

        <div className="relative flex gap-10">
          {HERO_STATS.map(({ big, label }) => (
            <div key={label}>
              <div className="text-2xl font-extrabold text-hero-accent">{big}</div>
              <div className="mt-0.5 text-xs uppercase tracking-wide text-white/55">{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ---- faixa hero (mobile) ---- */}
      <div className="relative overflow-hidden bg-hero px-6 pb-12 pt-8 text-white lg:hidden">
        <div className="hero-glow" aria-hidden="true" />
        <div className="relative">
          <Wordmark small />
          <h1 className="mt-4 font-black italic uppercase leading-[0.95] tracking-[-0.035em] text-3xl">
            A cada <span className="text-hero-accent">missão</span>
            <br />
            um novo <span className="text-hero-accent">aprendizado</span>.
          </h1>
        </div>
      </div>

      {/* ---- coluna do form ---- */}
      <div className="relative -mt-6 flex flex-1 flex-col rounded-t-3xl bg-background px-4 pb-6 pt-8 lg:mt-0 lg:w-1/2 lg:rounded-none lg:px-8 lg:pt-0">
        <div className="mx-auto flex w-full max-w-[400px] flex-1 flex-col justify-center gap-6 lg:min-h-screen lg:py-10">
          {children}

          <div className="flex flex-col gap-2 text-xs text-muted-foreground sm:flex-row sm:justify-between">
            <p>© {new Date().getFullYear()} EDURPG.IA</p>
            <div className="flex justify-start gap-4">
              <a href="/termos" className="hover:underline">Termos</a>
              <a href="/privacidade" className="hover:underline">Privacidade</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
